"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1],{

/***/ 2344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ UserProvider; },
  "e": function() { return /* binding */ useUserState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
;// CONCATENATED MODULE: ./src/mocks/mockuser.json
var mockuser_namespaceObject = JSON.parse('{"id":1522742,"name":"Test Account","email":"Test.Account@themuse.com","cropped_name":"Tester","favorite_posts":[{"id":655045,"post_id":10493},{"id":677478,"post_id":24282}],"company":{"id":894,"short_name":"yext","name":"Yext"},"logged_in":true,"view_bookings":false,"location":{"city":"New York","region":"New York","country":"United States","dma":"New York, NY","lat":40.7524,"lon":-73.9875,"accuracy_radius":10}}');
;// CONCATENATED MODULE: ./src/hooks/UserContext.tsx





const defaultUserState = {
    isInitialized: false,
    logged_in: false,
    view_bookings: false
};
const UserContext = /*#__PURE__*/ react.createContext(defaultUserState);
const UserProvider = (props)=>{
    const { children , user , userLocation  } = props;
    const initialState = user ? {
        ...user,
        location: userLocation
    } : {
        ...defaultUserState,
        location: userLocation
    };
    const { 0: userState , 1: setUserState  } = (0,react.useState)(initialState);
    const { publicRuntimeConfig: { museWebHost , appName  }  } = (0,config["default"])();
    (0,react.useEffect)(()=>{
        const fetchUser = async ()=>{
            // the default logged out user.
            const base = {
                logged_in: false,
                view_bookings: false
            };
            const msg = `${appName} was unable to fetch current user from ${museWebHost}/api/user.`;
            const isLocal = window.location.host.includes("local");
            if (isLocal) {
                setUserState({
                    ...mockuser_namespaceObject,
                    location: userState.location,
                    isInitialized: true
                });
                return;
            }
            try {
                const response = await fetch(`${museWebHost}/api/user`, {
                    credentials: "include"
                });
                // If we are not a 200 we can still get a valid response but it will cause errors.
                if (response.status !== 200) {
                    throw new Error(`${msg} status: ${response.status}`);
                }
                const result = await response.json();
                setUserState({
                    ...result,
                    location: userState.location,
                    isInitialized: true
                });
            } catch (error) {
                console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
                    error
                })));
                setUserState({
                    ...base,
                    location: userState.location,
                    isInitialized: true
                });
            }
        };
        fetchUser();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserContext.Provider, {
        value: {
            ...userState,
            location: userLocation
        },
        children: children
    });
};
const useUserState = ()=>{
    const context = react.useContext(UserContext);
    if (context === undefined) {
        throw new Error("useUserState must be used within the SearchProvider");
    }
    return context;
};



/***/ }),

/***/ 2919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ formatJobsResponse; },
/* harmony export */   "q": function() { return /* binding */ getMuseJobsConfig; }
/* harmony export */ });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);
/* harmony import */ var utils_strings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2918);
/* harmony import */ var _utils_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7228);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3135);
/* eslint-disable camelcase */ 



/**
 * Formatter for The Muse Jobs.
 * This is the default.
 */ const getFormattedQueryParams = (queryParams = null)=>({
        ...queryParams,
        ...{
            query: queryParams?.query?.substring(0, _utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .jobSearchQueryMaxlength */ .L8) ?? ""
        }
    });
/**
 * Returns the Axios config for requesting Jobs from TheMuse.
 */ const getMuseJobsConfig = (queryParams, ctsEnabled, cookies)=>{
    const { serverRuntimeConfig: { jobsApiHost  }  } = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])();
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs  }  } = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])();
    const searchVersion = ctsEnabled ? "cts_search" : "search";
    const path = (0,_utils_browser__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU)() ? `${apiBase}/jobs?ctsEnabled=${ctsEnabled}` : `${jobsApiHost}/api/v2/${searchVersion}/jobs`;
    const formattedQueryParams = getFormattedQueryParams(queryParams);
    const museConfig = {
        method: "GET",
        url: path,
        headers: (0,_utils_browser__WEBPACK_IMPORTED_MODULE_2__/* .isBrowser */ .jU)() ? {} : {
            Cookie: cookies || ""
        },
        params: {
            ...formattedQueryParams,
            timeout: apiRequestTimeoutMs
        }
    };
    return museConfig;
};
const formatJobsResponse = (jobsResponse)=>{
    const { count =0 , hits =[]  } = jobsResponse;
    const cleanHits = hits.map((x)=>{
        const { // so we can restructure the hit object.
        hit , ...restJobSearchHit } = x;
        const { posted_at , company , ...restProps } = hit;
        const { // specifically naming the items we want to keep as some are huge and unused.
        // Never ever use package as a property name. It will jack with the imports.
        legacy_id , logo , name , short_name , client_tier , package: pkg  } = company;
        return {
            ...restJobSearchHit,
            hit: {
                ...restProps,
                posted_at,
                postedDate: (0,utils_strings__WEBPACK_IMPORTED_MODULE_1__/* .formatDate */ .p6)(new Date(posted_at * 1000)),
                // Rebuild the company object with only the items we needed.
                company: {
                    legacy_id,
                    logo,
                    name,
                    short_name,
                    client_tier,
                    pkg
                }
            }
        };
    });
    const results = [
        ...cleanHits
    ];
    return {
        totalCount: count,
        results,
        // set the outer cursor to the last one in the set.
        cursor: results[results.length - 1]?.cursor ?? ""
    };
};



/***/ }),

/***/ 7248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ formatLocations; },
/* harmony export */   "z": function() { return /* binding */ getLocationConfig; }
/* harmony export */ });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);

/**
 * formatMuseLocationResponse: Formatter for Muse locations.
 * This is the default.
 */ const formatMuseLocationResponse = (content)=>{
    if (!content?.length) {
        return [];
    }
    return content.map((location)=>({
            label: location?.label,
            latitude: location?.latitude,
            longitude: location?.longitude,
            remote_work_location_type: location?.remote_work_location_type,
            value: location?.label,
            id: null
        }));
};
/**
 * formatLocations: Cleanup the results from a location request for use within the location suggestor.
 * formerly formatLocationResponse
 */ const formatLocations = (content)=>formatMuseLocationResponse(content);
/**
 * Returns the Axios config for requesting locations from TheMuse.
 */ const getMuseLocationConfig = (searchText)=>{
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs  }  } = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])();
    return {
        url: `${apiBase}/locations?query=${searchText}`,
        method: "GET",
        headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json"
        },
        timeout: apiRequestTimeoutMs
    };
};
/**
 * Returns the Axios config for requesting locations.
 */ const getLocationConfig = (searchText)=>{
    const config = getMuseLocationConfig(searchText);
    return config;
};



/***/ }),

/***/ 3309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SC": function() { return /* binding */ fetchCompanySuggestions; },
  "zA": function() { return /* binding */ fetchJobRecommendations; },
  "yZ": function() { return /* binding */ fetchJobTitleCities; },
  "bG": function() { return /* binding */ fetchJobs; },
  "gy": function() { return /* binding */ fetchLocationSuggestions; },
  "Ml": function() { return /* binding */ jobAlertsSubscribeRequest; },
  "Pl": function() { return /* binding */ newsletterSubscribeRequest; }
});

// UNUSED EXPORTS: ApiError, combinedSubscribe, fetchApiCompanySuggestions, fetchApiLocationSuggestions, fetchApiUser, fetchCompanyAttributes, fetchLocations, formatCompanySuggestions, formatLocationResponse, getCompanyAttributesConfig, jobAlertsApiSubscribeRequest, newsletterApiSubscribeRequest

// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
// EXTERNAL MODULE: ./node_modules/next/config.js
var next_config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/node-cache/index.js
var node_cache = __webpack_require__(7915);
var node_cache_default = /*#__PURE__*/__webpack_require__.n(node_cache);
// EXTERNAL MODULE: ./src/utils/logging.ts
var logging = __webpack_require__(4453);
// EXTERNAL MODULE: ./src/orm/jobs.ts
var jobs = __webpack_require__(2919);
// EXTERNAL MODULE: ./src/orm/locations.ts
var locations = __webpack_require__(7248);
;// CONCATENATED MODULE: ./src/mocks/companies.json
var companies_namespaceObject = JSON.parse('[{"object":"suggestion","type":"company_name","text":"The Muse","value":{"object":"company_name_suggestion","short_name":"themuse"}},{"object":"suggestion","type":"company_name","text":"Facebook","value":{"object":"company_name_suggestion","short_name":"facebook"}},{"object":"suggestion","type":"company_name","text":"The Music Company","value":{"object":"company_name_suggestion","short_name":"themusiccompany"}},{"object":"suggestion","type":"company_name","text":"Facetweet","value":{"object":"company_name_suggestion","short_name":"facetweet"}},{"object":"suggestion","type":"company_name","text":"Facetweet","value":{"object":"company_name_suggestion","short_name":"mycompanycom5"}},{"object":"suggestion","type":"company_name","text":"Test Company 6","value":{"object":"company_name_suggestion","short_name":"testcompany6"}},{"object":"suggestion","type":"company_name","text":"Company 7","value":{"object":"company_name_suggestion","short_name":"company7"}},{"object":"suggestion","type":"company_name","text":"Test Company 8","value":{"object":"company_name_suggestion","short_name":"testcompany8"}},{"object":"suggestion","type":"company_name","text":"Company 9","value":{"object":"company_name_suggestion","short_name":"company9"}},{"object":"suggestion","type":"company_name","text":"Test Company 10","value":{"object":"company_name_suggestion","short_name":"testcompany10"}},{"object":"suggestion","type":"company_name","text":"MyCompany.com 11","value":{"object":"company_name_suggestion","short_name":"mycompanycom11"}},{"object":"suggestion","type":"company_name","text":"Company 12","value":{"object":"company_name_suggestion","short_name":"company12"}},{"object":"suggestion","type":"company_name","text":"Test Company 13","value":{"object":"company_name_suggestion","short_name":"testcompany13"}},{"object":"suggestion","type":"company_name","text":"Test Company 14","value":{"object":"company_name_suggestion","short_name":"longnamecompany14"}},{"object":"suggestion","type":"company_name","text":"Another Long Name Company 15","value":{"object":"company_name_suggestion","short_name":"anotherlongnamecompany15"}},{"object":"suggestion","type":"company_name","text":"Another Long Name Company 16","value":{"object":"company_name_suggestion","short_name":"anotherlongnamecompany16"}},{"object":"suggestion","type":"company_name","text":"Long Name Company 17","value":{"object":"company_name_suggestion","short_name":"longnamecompany17"}},{"object":"suggestion","type":"company_name","text":"Long Name Company 18","value":{"object":"company_name_suggestion","short_name":"longnamecompany18"}},{"object":"suggestion","type":"company_name","text":"Test Company 19","value":{"object":"company_name_suggestion","short_name":"testcompany19"}},{"object":"suggestion","type":"company_name","text":"Another Long Name Company 20","value":{"object":"company_name_suggestion","short_name":"anotherlongnamecompany20"}},{"object":"suggestion","type":"company_name","text":"Another Long Name Company 21","value":{"object":"company_name_suggestion","short_name":"anotherlongnamecompany21"}},{"object":"suggestion","type":"company_name","text":"Company 22","value":{"object":"company_name_suggestion","short_name":"company22"}},{"object":"suggestion","type":"company_name","text":"Another Long Name Company 23","value":{"object":"company_name_suggestion","short_name":"anotherlongnamecompany23"}},{"object":"suggestion","type":"company_name","text":"Test Company 24","value":{"object":"company_name_suggestion","short_name":"testcompany24"}},{"object":"suggestion","type":"company_name","text":"Company 25","value":{"object":"company_name_suggestion","short_name":"company25"}},{"object":"suggestion","type":"company_name","text":"Long Name Company 26","value":{"object":"company_name_suggestion","short_name":"longnamecompany26"}},{"object":"suggestion","type":"company_name","text":"MyCompany.com 27","value":{"object":"company_name_suggestion","short_name":"mycompanycom27"}},{"object":"suggestion","type":"company_name","text":"Company 28","value":{"object":"company_name_suggestion","short_name":"company28"}},{"object":"suggestion","type":"company_name","text":"Long Name Company 29","value":{"object":"company_name_suggestion","short_name":"longnamecompany29"}},{"object":"suggestion","type":"company_name","text":"Test Company 30","value":{"object":"company_name_suggestion","short_name":"testcompany30"}}]');
;// CONCATENATED MODULE: ./src/mocks/mockCompanies.ts

const mockCompanies_mockCompanies = (companyFilter = "")=>{
    const results = {
        object: "suggestions",
        data: []
    };
    const companyFilterLowerCase = companyFilter.toLowerCase();
    if (companyFilter) {
        results.data = companies_namespaceObject.filter((company)=>{
            const companyLowerCase = company.text.toLowerCase();
            return companyLowerCase.includes(companyFilterLowerCase) ? company : null;
        });
    } else {
        results.data = companies_namespaceObject;
    }
    return results;
};


;// CONCATENATED MODULE: ./src/mocks/mockCompanyAttributes.json
var mockCompanyAttributes_namespaceObject = {};
;// CONCATENATED MODULE: ./src/mocks/mockRecommendations.json
var mockRecommendations_namespaceObject = JSON.parse('{"page":0,"page_count":625,"items_per_page":12,"took":null,"timed_out":"false","total":7501,"results":[{"id":5511108,"name":"Director, Regulatory Submissions Operations","short_name":"director-regulatory-submissions-operations","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/11661/small_logo.png","company_name":"JUUL Labs","company_short_name":"juullabs","company_id":11661,"company_description":"JUUL Labs provides a healthier alternative to smoking tobacco.  ","company_short_description":"JUUL Labs\' mission is to improve the lives of the world’s one billion adult smokers.","level_displays":["Senior Level"],"apply_link":"https://staging-themuse.com/jobs/juullabs/director-regulatory-submissions-operations","external_apply_link":null,"location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5508598,"name":"Executive Assistant, External Affairs","short_name":"executive-assistant-external-affairs","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/11661/small_logo.png","company_name":"JUUL Labs","company_short_name":"juullabs","company_id":11661,"company_description":"JUUL Labs provides a healthier alternative to smoking tobacco.  ","company_short_description":"JUUL Labs\' mission is to improve the lives of the world’s one billion adult smokers.","level_displays":["Senior Level"],"apply_link":"https://staging-themuse.com/jobs/juullabs/executive-assistant-external-affairs","external_apply_link":null,"location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5399760,"name":"[Data] Analytics Manager","short_name":"data-analytics-manager","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/1468/small_logo.png","company_name":"Checkr","company_short_name":"checkr","company_id":1468,"company_description":"Checkr aims to build a fairer future by improving the understanding of the past. The company provides modern and compliant background checks for global enterprises and startups.","company_short_description":"Checkr conducts comprehensive background checks.","level_displays":["Senior Level"],"apply_link":"https://staging-themuse.com/jobs/checkr/data-analytics-manager","external_apply_link":"https://boards.greenhouse.io/checkr/jobs/3747006?gh_src=015yha1","location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5509675,"name":"Developer Advocate Intern","short_name":"developer-advocate-intern","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/519/small_logo.png","company_name":"DigitalOcean","company_short_name":"digitalocean","company_id":519,"company_description":"DigitalOcean offers cloud space server solutions—created by developers, for developers. ","company_short_description":"","level_displays":["Internship"],"apply_link":"https://staging-themuse.com/jobs/digitalocean/developer-advocate-intern","external_apply_link":null,"location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5288222,"name":"Staff Data Engineer - Pandora","short_name":"staff-data-engineer-pandora","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/921/small_logo.png","company_name":"Pandora","company_short_name":"pandora","company_id":921,"company_description":"Pandora is a personalized radio service, available anytime and anywhere through connected devices. The company’s goal is to play music that its listeners will love every time they tune in.","company_short_description":"Pandora is a music discovery platform where artists find their fans and listeners find music they love.","level_displays":["Senior Level"],"apply_link":"https://staging-themuse.com/jobs/pandora/staff-data-engineer-pandora","external_apply_link":"http://app.jobvite.com/CompanyJobs/Job.aspx?c=qhd9Vfwi&j=oCyjgfwt&s=TheMuse","location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5509633,"name":"Manager, Advisor Sales","short_name":"manager-advisor-sales-aeb6b6","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/1191/small_logo.png","company_name":"eMoney","company_short_name":"emoney","company_id":1191,"company_description":"eMoney Advisor builds process-simplifying technology solutions that allow financial firm advisors to follow industry trends and build better relationships with their company clients.","company_short_description":"","level_displays":["Senior Level"],"apply_link":"https://staging-themuse.com/jobs/emoney/manager-advisor-sales-aeb6b6","external_apply_link":null,"location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5506194,"name":"Senior UX Designer","short_name":"senior-ux-designer","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/1191/small_logo.png","company_name":"eMoney","company_short_name":"emoney","company_id":1191,"company_description":"eMoney Advisor builds process-simplifying technology solutions that allow financial firm advisors to follow industry trends and build better relationships with their company clients.","company_short_description":"","level_displays":["Senior Level"],"apply_link":"https://staging-themuse.com/jobs/emoney/senior-ux-designer","external_apply_link":null,"location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5506199,"name":"Marketing Operations Coordinator","short_name":"marketing-operations-coordinator","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/1191/small_logo.png","company_name":"eMoney","company_short_name":"emoney","company_id":1191,"company_description":"eMoney Advisor builds process-simplifying technology solutions that allow financial firm advisors to follow industry trends and build better relationships with their company clients.","company_short_description":"","level_displays":["Mid Level"],"apply_link":"https://staging-themuse.com/jobs/emoney/marketing-operations-coordinator","external_apply_link":null,"location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5505925,"name":"UX Designer II","short_name":"ux-designer-ii","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/1268/small_logo.png","company_name":"USA TODAY NETWORK","company_short_name":"usatodaynetwork","company_id":1268,"company_description":"USA TODAY NETWORK brings timely news and entertainment right to the fingertips of readers around the country by pairing innovative technology with razor-sharp reporting and storytelling.","company_short_description":"","level_displays":["Mid Level"],"apply_link":"https://staging-themuse.com/jobs/usatodaynetwork/ux-designer-ii","external_apply_link":null,"location_values":["Barstow, CA","Dublin, GA","Gambrills, MD","Holly Springs, NC","Manhattan, NY","McLean, VA","Milton, DE","Milwaukee, WI","New York, NY","Rochester, NY","Scottsville, VA","Sebring, FL","Waltham, MA","Watertown, CT","Williamsport, PA","Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5509498,"name":"Marketing and Communications Manager (Remote)","short_name":"marketing-and-communications-manager-remote","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/1268/small_logo.png","company_name":"USA TODAY NETWORK","company_short_name":"usatodaynetwork","company_id":1268,"company_description":"USA TODAY NETWORK brings timely news and entertainment right to the fingertips of readers around the country by pairing innovative technology with razor-sharp reporting and storytelling.","company_short_description":"","level_displays":["Senior Level"],"apply_link":"https://staging-themuse.com/jobs/usatodaynetwork/marketing-and-communications-manager-remote","external_apply_link":null,"location_values":["Buffalo Grove, IL","Chicago, IL","Delaware, OH","McLean, VA","Minneapolis, MN","New York, NY","Rochester, NY","Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5509501,"name":"Social Media Reporter/Producer","short_name":"social-media-reporterproducer","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/1268/small_logo.png","company_name":"USA TODAY NETWORK","company_short_name":"usatodaynetwork","company_id":1268,"company_description":"USA TODAY NETWORK brings timely news and entertainment right to the fingertips of readers around the country by pairing innovative technology with razor-sharp reporting and storytelling.","company_short_description":"","level_displays":["Mid Level"],"apply_link":"https://staging-themuse.com/jobs/usatodaynetwork/social-media-reporterproducer","external_apply_link":null,"location_values":["Nashville, TN","Shelbyville, TN","Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"},{"id":5509448,"name":"Remote - Software Engineer II","short_name":"remote-software-engineer-ii-3464cd","company_logo_image":"https://assets.staging-themuse.com/uploaded/companies/1284/small_logo.png","company_name":"Availity","company_short_name":"availity","company_id":1284,"company_description":"Availity delivers technology-based business solutions for health care professionals who want to build healthy, thriving organizations by working with patients and partners all around the country.","company_short_description":"","level_displays":["Mid Level"],"apply_link":"https://staging-themuse.com/jobs/availity/remote-software-engineer-ii-3464cd","external_apply_link":null,"location_values":["Flexible / Remote"],"model_type":"jobs","relevance_score":22.280624,"type":"external"}]}');
;// CONCATENATED MODULE: ./src/mocks/jobs.json
var jobs_namespaceObject = JSON.parse('{"object":"search_hits","has_more":false,"count":1000,"hits":[{"object":"search_hit","hit":{"object":"job_search_hit","id":"04255833-6b85-48b8-884f-be513fe54389","snowplow_id":"04255833-6b85-48b8-884f-be513fe54389","legacy_id":5516535,"title":"Senior Accounts Receivable Analyst","short_title":"senior-accounts-receivable-analyst","apply_type":"external","company":{"name":"Atlassian","short_name":"atlassian","logo":"https://assets.staging-themuse.com/uploaded/companies/741/small_logo.png","legacy_id":741,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE","JobCategory.ADMINISTRATIVE_AND_OFFICE"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Manila, NCR","latitude":14.5995124,"longitude":120.9842195,"locality":"Manila","region":"NCR","country":"PH"}],"remote_work_location_type":null,"posted_at":1682456015},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"bb5815c6-b799-47a6-a23f-284d5db8f3ed","snowplow_id":"bb5815c6-b799-47a6-a23f-284d5db8f3ed","legacy_id":5515553,"title":"Cost Center Analyst","short_title":"cost-center-analyst","apply_type":"external","company":{"name":"84.51°","short_name":"8451","logo":"https://assets.staging-themuse.com/uploaded/companies/1619/small_logo.png","legacy_id":1619,"perks_and_benefits":[{"name":"Dental Insurance","code":"dental_insurance"},{"name":"Health Reimbursement Account","code":"health_reimbursement_account"},{"name":"Paid Vacation","code":"paid_vacation"}],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"mid","code":"mid"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Manchester, England","latitude":53.4807593,"longitude":-2.2426305,"locality":"Manchester","region":"England","country":"GB"}],"remote_work_location_type":null,"posted_at":1682012606},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"a8b66efe-46f8-4338-b339-c7ad05aa8a9b","snowplow_id":"a8b66efe-46f8-4338-b339-c7ad05aa8a9b","legacy_id":5516653,"title":"Accounting Intern, Revenue Team 2023","short_title":"accounting-intern-revenue-team-2023","apply_type":"external","company":{"name":"Atlassian","short_name":"atlassian","logo":"https://assets.staging-themuse.com/uploaded/companies/741/small_logo.png","legacy_id":741,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"internship","code":"internship"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Manila, NCR","latitude":14.5995124,"longitude":120.9842195,"locality":"Manila","region":"NCR","country":"PH"}],"remote_work_location_type":null,"posted_at":1682456164},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"2661ad81-5f55-42f3-bacc-3c0e5e434ba5","snowplow_id":"2661ad81-5f55-42f3-bacc-3c0e5e434ba5","legacy_id":5516437,"title":"Benefits Admin Senior Associate","short_title":"benefits-admin-senior-associate","apply_type":"external","company":{"name":"Allstate","short_name":"allstate","logo":"https://assets.staging-themuse.com/uploaded/companies/891/small_logo.png","legacy_id":891,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.HUMAN_RESOURCES","JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Milwaukee, WI","latitude":42.959795,"longitude":-87.93978,"locality":"Milwaukee","region":"WI","country":"US"}],"remote_work_location_type":null,"posted_at":1682455895},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"007c62c5-1de2-4111-a011-a4a1c664b434","snowplow_id":"007c62c5-1de2-4111-a011-a4a1c664b434","legacy_id":5516260,"title":"Advisor, Financial Analysis","short_title":"advisor-financial-analysis","apply_type":"external","company":{"name":"1-800 Contacts","short_name":"1800contacts","logo":"https://assets.staging-themuse.com/uploaded/companies/1221/small_logo.png","legacy_id":1221,"perks_and_benefits":[{"name":"Health Insurance","code":"health_insurance"},{"name":"Health Reimbursement Account","code":"health_reimbursement_account"},{"name":"HSA Account","code":"hsa"}],"leadership_attributes":[],"package":null,"client_tier":"lite"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Austin, TX","latitude":30.267153,"longitude":-97.7430608,"locality":"Austin","region":"TX","country":"US"},{"address":"Westborough, MA","latitude":42.2695216,"longitude":-71.61612939999999,"locality":"Westborough","region":"MA","country":"US"}],"remote_work_location_type":null,"posted_at":1682027660},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"1737f03a-2fb8-4e25-a5b3-26900b6fde53","snowplow_id":"1737f03a-2fb8-4e25-a5b3-26900b6fde53","legacy_id":5516646,"title":"Medicare Benefit Advisor (Unlicensed) - Remote Inside Sales in Arizona","short_title":"medicare-benefit-advisor-unlicensed-remote-inside-sales-in-arizona","apply_type":"external","company":{"name":"Allstate","short_name":"allstate","logo":"https://assets.staging-themuse.com/uploaded/companies/891/small_logo.png","legacy_id":891,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.HUMAN_RESOURCES","JobCategory.ACCOUNTING_AND_FINANCE","JobCategory.SALES_AND_RETAIL"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Tempe, AZ","latitude":33.3487609,"longitude":-111.9442918,"locality":"Tempe","region":"AZ","country":"US"}],"remote_work_location_type":null,"posted_at":1682456154},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"572255ae-1455-4f8f-a08c-419ee3be4452","snowplow_id":"572255ae-1455-4f8f-a08c-419ee3be4452","legacy_id":5514966,"title":"Internship, Finance & Accounting (2022 Intake)","short_title":"internship-finance-accounting-2022-intake","apply_type":"external","company":{"name":"1-800 Contacts","short_name":"1800contacts","logo":"https://assets.staging-themuse.com/uploaded/companies/1221/small_logo.png","legacy_id":1221,"perks_and_benefits":[{"name":"Health Insurance","code":"health_insurance"},{"name":"Health Reimbursement Account","code":"health_reimbursement_account"},{"name":"HSA Account","code":"hsa"}],"leadership_attributes":[],"package":null,"client_tier":"lite"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"internship","code":"internship"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Bayan Lepas, Pulau Pinang","latitude":5.323258,"longitude":100.273172,"locality":"Bayan Lepas","region":"Pulau Pinang","country":"MY"}],"remote_work_location_type":null,"posted_at":1682010395},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"01d13684-ae2f-4f2c-beda-9f114a29b457","snowplow_id":"01d13684-ae2f-4f2c-beda-9f114a29b457","legacy_id":5517016,"title":"Workday HRIS Manager","short_title":"workday-hris-manager","apply_type":"external","company":{"name":"Accolade","short_name":"accolade","logo":"https://assets.staging-themuse.com/uploaded/companies/849/small_logo.png","legacy_id":849,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[{"name":"Education","code":"education"}],"google_categories":["JobCategory.MANAGEMENT","JobCategory.HUMAN_RESOURCES","JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Seattle, WA","latitude":47.6070581,"longitude":-122.3360669,"locality":"Seattle","region":"WA","country":"US"}],"remote_work_location_type":"virtual","posted_at":1694710636},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"0f086665-548f-4625-9a59-5892d3b425f7","snowplow_id":"0f086665-548f-4625-9a59-5892d3b425f7","legacy_id":5515946,"title":"Rotational Finance Intern","short_title":"rotational-finance-intern-95e4dc","apply_type":"external","company":{"name":"84.51°","short_name":"8451","logo":"https://assets.staging-themuse.com/uploaded/companies/1619/small_logo.png","legacy_id":1619,"perks_and_benefits":[{"name":"Dental Insurance","code":"dental_insurance"},{"name":"Health Reimbursement Account","code":"health_reimbursement_account"},{"name":"Paid Vacation","code":"paid_vacation"}],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"internship","code":"internship"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Grand Rapids, MI","latitude":42.9633599,"longitude":-85.6680863,"locality":"Grand Rapids","region":"MI","country":"US"}],"remote_work_location_type":null,"posted_at":1682027120},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"0c2df05f-58d1-499d-a02a-1791890b2193","snowplow_id":"0c2df05f-58d1-499d-a02a-1791890b2193","legacy_id":5516940,"title":"Manager, Claims","short_title":"manager-claims-23484e","apply_type":"external","company":{"name":"Airbnb","short_name":"airbnb","logo":"https://assets.staging-themuse.com/uploaded/companies/11/small_logo.png","legacy_id":11,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[{"name":"Data and Analytics","code":"data_analytics"}],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE","JobCategory.MANAGEMENT"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Gurugram, HR","latitude":28.5108181,"longitude":77.08558649999999,"locality":"Gurugram","region":"HR","country":"IN"}],"remote_work_location_type":null,"posted_at":1689987266},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"e5291b93-6cf8-4659-9cec-abd5f5ac66af","snowplow_id":"e5291b93-6cf8-4659-9cec-abd5f5ac66af","legacy_id":5516987,"title":"Senior Staff Housing Economist","short_title":"senior-staff-housing-economist","apply_type":"external","company":{"name":"Airbnb","short_name":"airbnb","logo":"https://assets.staging-themuse.com/uploaded/companies/11/small_logo.png","legacy_id":11,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[{"name":"Data and Analytics","code":"data_analytics"}],"google_categories":["JobCategory.SCIENCE_AND_ENGINEERING","JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":", ","latitude":37.09024,"longitude":-95.712891,"locality":"","region":"","country":"US"}],"remote_work_location_type":null,"posted_at":1689987362},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"af74ac42-d0d5-46ea-897a-0b5804754ccc","snowplow_id":"af74ac42-d0d5-46ea-897a-0b5804754ccc","legacy_id":5516343,"title":"Pricing Analyst","short_title":"pricing-analyst","apply_type":"external","company":{"name":"eMoney","short_name":"emoney","logo":"https://assets.staging-themuse.com/uploaded/companies/1191/small_logo.png","legacy_id":1191,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.BUSINESS_OPERATIONS","JobCategory.ADVERTISING_AND_MARKETING","JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"mid","code":"mid"}],"search_text_snippet":"","job_title_snippet":"","locations":[],"remote_work_location_type":"virtual","posted_at":1682455240},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"ae2328df-184c-4332-ba9c-812b5e51a851","snowplow_id":"ae2328df-184c-4332-ba9c-812b5e51a851","legacy_id":5517025,"title":"Actuarial Intern","short_title":"actuarial-intern","apply_type":"external","company":{"name":"Accolade","short_name":"accolade","logo":"https://assets.staging-themuse.com/uploaded/companies/849/small_logo.png","legacy_id":849,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[{"name":"Data and Analytics","code":"data_analytics"}],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"internship","code":"internship"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Seattle, WA","latitude":47.6070581,"longitude":-122.3360669,"locality":"Seattle","region":"WA","country":"US"}],"remote_work_location_type":null,"posted_at":1694710644},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"94a3056d-54b0-48b6-959f-730de01dc1a3","snowplow_id":"94a3056d-54b0-48b6-959f-730de01dc1a3","legacy_id":5516289,"title":"Annuity Renewal Specialist","short_title":"annuity-renewal-specialist","apply_type":"external","company":{"name":"Kroger","short_name":"kroger","logo":"https://assets.staging-themuse.com/uploaded/companies/11671/small_logo.png","legacy_id":11671,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"mid","code":"mid"}],"search_text_snippet":"","job_title_snippet":"","locations":[],"remote_work_location_type":"virtual","posted_at":1682474327},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"d1d6b7c7-32c7-4772-82d7-4f35affd6ce7","snowplow_id":"d1d6b7c7-32c7-4772-82d7-4f35affd6ce7","legacy_id":5512124,"title":"Credit Advisor","short_title":"credit-advisor","apply_type":"external","company":{"name":"1-800 Contacts","short_name":"1800contacts","logo":"https://assets.staging-themuse.com/uploaded/companies/1221/small_logo.png","legacy_id":1221,"perks_and_benefits":[{"name":"Health Insurance","code":"health_insurance"},{"name":"Health Reimbursement Account","code":"health_reimbursement_account"},{"name":"HSA Account","code":"hsa"}],"leadership_attributes":[],"package":null,"client_tier":"lite"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[],"remote_work_location_type":"virtual","posted_at":1682005006},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"2df0870b-1ea8-4637-892b-ce07a932d1ef","snowplow_id":"2df0870b-1ea8-4637-892b-ce07a932d1ef","legacy_id":5516645,"title":"Medicare Benefit Advisor (Unlicensed) - Remote Inside Sales in Virginia","short_title":"medicare-benefit-advisor-unlicensed-remote-inside-sales-in-virginia","apply_type":"external","company":{"name":"Allstate","short_name":"allstate","logo":"https://assets.staging-themuse.com/uploaded/companies/891/small_logo.png","legacy_id":891,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.HUMAN_RESOURCES","JobCategory.ACCOUNTING_AND_FINANCE","JobCategory.SALES_AND_RETAIL"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Falls Church, VA","latitude":38.8865202,"longitude":-77.16569129999999,"locality":"Falls Church","region":"VA","country":"US"}],"remote_work_location_type":null,"posted_at":1682456152},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"93818fdd-51b4-4bb3-b95a-c51a5df13bdd","snowplow_id":"93818fdd-51b4-4bb3-b95a-c51a5df13bdd","legacy_id":5514963,"title":"Internship, Finance & Accounting","short_title":"internship-finance-accounting","apply_type":"external","company":{"name":"1-800 Contacts","short_name":"1800contacts","logo":"https://assets.staging-themuse.com/uploaded/companies/1221/small_logo.png","legacy_id":1221,"perks_and_benefits":[{"name":"Health Insurance","code":"health_insurance"},{"name":"Health Reimbursement Account","code":"health_reimbursement_account"},{"name":"HSA Account","code":"hsa"}],"leadership_attributes":[],"package":null,"client_tier":"lite"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"internship","code":"internship"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Bayan Lepas, Pulau Pinang","latitude":5.323258,"longitude":100.273172,"locality":"Bayan Lepas","region":"Pulau Pinang","country":"MY"}],"remote_work_location_type":null,"posted_at":1682010391},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"07d4a716-54b4-4fa4-8cc9-312f184c3bda","snowplow_id":"07d4a716-54b4-4fa4-8cc9-312f184c3bda","legacy_id":5515770,"title":"Cost Accountant","short_title":"cost-accountant-27ea38","apply_type":"external","company":{"name":"84.51°","short_name":"8451","logo":"https://assets.staging-themuse.com/uploaded/companies/1619/small_logo.png","legacy_id":1619,"perks_and_benefits":[{"name":"Dental Insurance","code":"dental_insurance"},{"name":"Health Reimbursement Account","code":"health_reimbursement_account"},{"name":"Paid Vacation","code":"paid_vacation"}],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"mid","code":"mid"}],"search_text_snippet":"","job_title_snippet":"","locations":[],"remote_work_location_type":"virtual","posted_at":1682012863},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"c77f42c2-949a-4c14-bed1-811738df61c9","snowplow_id":"c77f42c2-949a-4c14-bed1-811738df61c9","legacy_id":5516504,"title":"Fraud Consultant","short_title":"fraud-consultant","apply_type":"external","company":{"name":"Allstate","short_name":"allstate","logo":"https://assets.staging-themuse.com/uploaded/companies/891/small_logo.png","legacy_id":891,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.LEGAL","JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"Chicago, IL","latitude":41.8523821,"longitude":-87.67412,"locality":"Chicago","region":"IL","country":"US"}],"remote_work_location_type":null,"posted_at":1682455979},"cursor":"-"},{"object":"search_hit","hit":{"object":"job_search_hit","id":"cb246861-eecc-4e2a-9dba-60ed80f8f6dc","snowplow_id":"cb246861-eecc-4e2a-9dba-60ed80f8f6dc","legacy_id":5516523,"title":"Internal Audit Manager","short_title":"internal-audit-manager","apply_type":"external","company":{"name":"Atlassian","short_name":"atlassian","logo":"https://assets.staging-themuse.com/uploaded/companies/741/small_logo.png","legacy_id":741,"perks_and_benefits":[],"leadership_attributes":[],"package":null,"client_tier":"None"},"employment_types":[],"categories":[],"google_categories":["JobCategory.MANAGEMENT","JobCategory.ACCOUNTING_AND_FINANCE"],"levels":[{"name":"senior","code":"senior"}],"search_text_snippet":"","job_title_snippet":"","locations":[{"address":"San Francisco, CA","latitude":37.7910081,"longitude":-122.4033221,"locality":"San Francisco","region":"CA","country":"US"}],"remote_work_location_type":null,"posted_at":1682456002},"cursor":"CBQSJDBlYTU2YTFkLWE3YmUtNGZiYi05N2UzLTM3NGQwYzMzZWMyMA=="}],"ctsSearch":true,"cts_centroid":""}');
;// CONCATENATED MODULE: ./src/mocks/locations.json
var locations_namespaceObject = JSON.parse('[{"object":"suggestion","type":"location","text":"Flexible / Remote","value":{"object":"location_suggestion","latitude":null,"longitude":null,"remote_work_location_type":"virtual"},"image":null},{"object":"suggestion","type":"location","text":"New York, NY","value":{"object":"location_suggestion","latitude":40.709999084472656,"longitude":-74.01000213623047,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Los Angeles, CA","value":{"object":"location_suggestion","latitude":34.0522346496582,"longitude":-118.24368286132812,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Chicago, IL","value":{"object":"location_suggestion","latitude":41.87811279296875,"longitude":-87.62979888916016,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Houston, TX","value":{"object":"location_suggestion","latitude":29.760427474975586,"longitude":-95.36980438232422,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Philadelphia, PA","value":{"object":"location_suggestion","latitude":39.95258331298828,"longitude":-75.16522216796875,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Phoenix, AZ","value":{"object":"location_suggestion","latitude":33.4483757019043,"longitude":-112.07404327392578,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"San Diego, CA","value":{"object":"location_suggestion","latitude":32.715736389160156,"longitude":-117.16108703613281,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Dallas, Texas","value":{"object":"location_suggestion","remote_work_location_type":null,"latitude":32.7766642,"longitude":-96.7969}},{"object":"suggestion","type":"location","text":"San Jose, CA","value":{"object":"location_suggestion","latitude":37.338199615478516,"longitude":-121.88629913330078,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Austin, TX","value":{"object":"location_suggestion","latitude":30.267152786254883,"longitude":-97.74305725097656,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Indianapolis, IN","value":{"object":"location_suggestion","latitude":39.768402099609375,"longitude":-86.15806579589844,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Jacksonville, FL","value":{"object":"location_suggestion","latitude":30.332183837890625,"longitude":-81.65564727783203,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"San Francisco, CA","value":{"object":"location_suggestion","latitude":37.77492904663086,"longitude":-122.41941833496094,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Charlotte, NC","value":{"object":"location_suggestion","latitude":35.22708511352539,"longitude":-80.84312438964844,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Detroit, MI","value":{"object":"location_suggestion","latitude":42.33142852783203,"longitude":-83.0457534790039,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Seattle, WA","value":{"object":"location_suggestion","latitude":47.60620880126953,"longitude":-122.33206939697266,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Denver, CO","value":{"object":"location_suggestion","latitude":39.739234924316406,"longitude":-104.99024963378906,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Washington, DC","value":{"object":"location_suggestion","latitude":38.90719223022461,"longitude":-77.03687286376953,"remote_work_location_type":null},"image":null},{"object":"suggestion","type":"location","text":"Boston, MA","value":{"object":"location_suggestion","latitude":42.36008071899414,"longitude":-71.05888366699219,"remote_work_location_type":null},"image":null}]');
;// CONCATENATED MODULE: ./src/mocks/mockLocations.ts

const mockLocations_mockLocations = (query = "")=>{
    const locations = {
        object: "suggestions",
        data: []
    };
    const locationValueLowered = query.toLowerCase();
    if (query) {
        locations.data = mockLocationValues.filter((location)=>{
            const locationValue = location.text.toLowerCase();
            return locationValue.includes(locationValueLowered) ? location : null;
        });
    } else {
        locations.data = mockLocationValues;
    }
    return locations;
};
// Resolves to The Muse's Office
const mockUserLocation = ()=>({
        city: "New York",
        region: "New York",
        country: "United States",
        dma: "New York, NY",
        lat: 40.7524,
        lon: -73.9875,
        accuracy_radius: 10
    });


;// CONCATENATED MODULE: ./src/mocks/mockJobsCities.json
var mockJobsCities_namespaceObject = JSON.parse('{"title":"Engineer","updated_at":"2024-01-25 18:19:59","cities":["New York","Schenectady"]}');
;// CONCATENATED MODULE: ./src/utils/errors.ts

/**
 * Returns an error message for a failed fetch request.
 *
 * @param thing - The thing being requested.
 * @param system - The system on which the request was made.
 * @param url - The URL of the request (optional).
 * @returns The error message.
 */ const getFetchError = (thing, system, url = "")=>{
    const { publicRuntimeConfig: { appName  }  } = (0,next_config["default"])();
    return `${appName} was unable to request ${thing} on the ${system}${url ? ` ${url}` : ""}.`;
};


// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
;// CONCATENATED MODULE: ./src/utils/api.ts
/* eslint-disable max-len */ 














/**
 * Creates a new instance of the NodeCache class
 * - standard time-to-live (TTL) of 86400 seconds
 * - check period of 300 seconds.
 */ const apiCache = new (node_cache_default())({
    stdTTL: 86400,
    checkperiod: 300
});
class ApiError extends Error {
    constructor(name, statusCode, message){
        super(message);
        this.name = name;
        this.statusCode = statusCode;
    }
}
/**
 * Request company suggestions.
 */ const fetchCompanySuggestions = async (inputValue)=>{
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs , appName  } , serverRuntimeConfig: { mockApiResponses  }  } = (0,next_config["default"])();
    const path = `${apiBase}/companies?query=${inputValue}`;
    try {
        const response = mockApiResponses ? {
            data: mockCompanies_mockCompanies(inputValue)
        } : await axios_default()(path, {
            timeout: apiRequestTimeoutMs
        });
        return response.data;
    } catch (error) {
        const msg = `${appName} was unable to request company suggestions from ${path}`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
        throw new Error(msg);
    }
};
/**
 * Returns the Axios config for requesting Jobs from TheMuse.
 */ const getCompanyAttributesConfig = ()=>{
    const { serverRuntimeConfig: { companyApiHost , companyApiToken  }  } = getConfig();
    const { publicRuntimeConfig: { apiRequestTimeoutMs  }  } = getConfig();
    const path = `${companyApiHost}/api/v1/companies/attributes`;
    const museConfig = {
        method: "GET",
        url: path,
        timeout: apiRequestTimeoutMs,
        headers: {
            Authorization: `Bearer ${companyApiToken}`
        }
    };
    return museConfig;
};
const fetchCompanyAttributes = async ()=>{
    const { serverRuntimeConfig: { appName , mockApiResponses  }  } = getConfig();
    const axiosConfig = getCompanyAttributesConfig();
    try {
        const response = mockApiResponses ? {
            data: mockCompanyAttributes
        } : await axios(axiosConfig);
        const ormResults = response.data;
        return ormResults;
    } catch (error) {
        const msg = `${appName} was unable to request company attributes from ${axiosConfig.url}`;
        console.error(msg, JSON.stringify(formatLog({
            error
        })));
        throw new Error(msg);
    }
};
/**
 * Request location suggestions.
 */ const fetchLocationSuggestions = async (inputValue)=>{
    const { serverRuntimeConfig: { mockApiResponses  } , publicRuntimeConfig: { appName  }  } = (0,next_config["default"])();
    let config;
    if (!inputValue) {
        return null;
    }
    try {
        config = (0,locations/* getLocationConfig */.z)(inputValue);
        const response = mockApiResponses ? {
            data: locations_namespaceObject
        } : await axios_default()(config);
        return response.data;
    } catch (error) {
        const msg = `${appName} was unable to request locations suggestions from ${config?.url}`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
        throw new Error(msg);
    }
};
/**
 * Request job recommendations.
 */ const fetchJobRecommendations = async ()=>{
    const { publicRuntimeConfig: { apiBase , apiRequestTimeoutMs , appName  } , serverRuntimeConfig: { mockApiResponses  }  } = (0,next_config["default"])();
    const path = `${apiBase}/recommendations`;
    try {
        const response = mockApiResponses ? {
            data: mockRecommendations_namespaceObject
        } : await axios_default().get(path, {
            timeout: apiRequestTimeoutMs
        });
        return response.data;
    } catch (error) {
        const msg = `${appName} was unable to request job recommendations from ${path}`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
        throw new Error(msg);
    }
};
/**
 * Request jobs directly from the backend API or proxied through the Next.js internal API.
 */ const fetchJobs = async (queryParams, ctsEnabled, cookies)=>{
    const { publicRuntimeConfig: { appName  } , serverRuntimeConfig: { mockApiResponses  }  } = (0,next_config["default"])();
    const axiosConfig = (0,jobs/* getMuseJobsConfig */.q)(queryParams, ctsEnabled, cookies);
    try {
        const response = mockApiResponses ? {
            data: jobs_namespaceObject
        } : await axios_default()(axiosConfig);
        return response.data;
    } catch (error) {
        const msg = `${appName} was unable to request job results from ${axiosConfig.url}`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
        throw new Error(msg);
    }
};
/**
 * Request company suggestions from the backend API.
 */ const fetchApiCompanySuggestions = async (query)=>{
    const { serverRuntimeConfig: { apiRequestTimeoutMs , jobsApiHost , appName , mockApiResponses  }  } = getConfig();
    // if query exists we will pass it in the params.
    const queryObj = query ? {
        query
    } : {};
    const config = {
        params: {
            type: "company_name",
            ...queryObj
        },
        timeout: apiRequestTimeoutMs
    };
    const path = `${jobsApiHost}/api/v2/suggestions`;
    try {
        const response = mockApiResponses ? {
            data: mockCompanies(queryObj.query)
        } : await axios(path, config);
        return response.data;
    } catch (error) {
        const msg = `${appName} was unable to request job suggestions server side from ${path}`;
        console.error(msg, JSON.stringify(formatLog({
            error
        })));
        throw new Error(msg);
    }
};
/**
 * Request locations from the backend API.
 */ const fetchLocations = async (userInput)=>{
    const location = userInput?.substring(0, suggestionApiQueryMaxlength);
    const { serverRuntimeConfig: { jobsApiHost , mockApiResponses  } , publicRuntimeConfig: { apiRequestTimeoutMs , appName  }  } = getConfig();
    const config = {
        params: {
            type: "location",
            query: location ?? ""
        },
        timeout: apiRequestTimeoutMs
    };
    const path = `${jobsApiHost}/api/v2/suggestions`;
    try {
        const response = mockApiResponses ? {
            data: mockLocations(location)
        } : await axios.get(path, config);
        return response.data;
    } catch (error) {
        const msg = `${appName} was unable to request locations server side from ${path}`;
        console.error(msg, JSON.stringify(formatLog({
            error
        })));
        throw new Error(msg);
    }
};
const formatLocationResponse = (response)=>response.map((location)=>({
            label: location.text,
            value: location.text,
            latitude: location.value.latitude,
            longitude: location.value.longitude,
            remote_work_location_type: location.value.remote_work_location_type
        }));
const fetchApiLocationSuggestions = async (userInput)=>{
    const locationsResponse = await fetchLocations(userInput);
    return formatLocationResponse(locationsResponse.data);
};
const formatCompanySuggestions = (suggestions)=>suggestions.map((company)=>({
            label: company.text,
            value: company.value.short_name
        }));
/**
 * job alerts optin from the public API.
 */ const jobAlertsSubscribeRequest = async (values, axiosOptions)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , apiBase  }  } = (0,next_config["default"])();
    const config = {
        ...{
            timeout: apiRequestTimeoutMs,
            headers: {
                "Content-Type": "application/json"
            }
        },
        ...axiosOptions
    };
    const path = `${apiBase}/job_alerts/subscribe`;
    try {
        const response = await axios_default().post(path, values, config);
        if (response.status === 200 || response.status === 201) {
            return true;
        }
        throw new Error(`Job Alerts subscription was unsuccessful. Status: ${response.status}`);
    } catch (error) {
        const msg = "Error: Job Alerts subscription was unsuccessful.";
        const err = JSON.stringify(error.response.data);
        console.error(msg, err);
        return false;
    }
};
/**
 * job alerts optin from the museweb service API.
 */ const jobAlertsApiSubscribeRequest = async (values, axiosOptions)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , museApiHost , museWebHost  } , serverRuntimeConfig: { emailAlertToken  }  } = getConfig();
    const config = {
        ...{
            timeout: apiRequestTimeoutMs,
            headers: {
                Authorization: `Shared-Token token=${emailAlertToken}`,
                Origin: museWebHost
            }
        },
        ...axiosOptions
    };
    const path = `${museApiHost}/api/job_alerts/subscribe`;
    try {
        const response = await axios.post(path, values, config);
        return response.data;
    } catch (error) {
        const msg = `Error subscribing the user at ${path}, job ID: ${values.jobId}, status: ${error.response?.status}`;
        const err = JSON.stringify(error.response?.data?.error);
        console.error(msg, err);
        throw new ApiError("ApiError", error.response?.status, err);
    }
};
/**
 * newsletter optin from the public API.
 */ const newsletterSubscribeRequest = async (values, axiosOptions)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , apiBase  }  } = (0,next_config["default"])();
    const config = {
        ...{
            timeout: apiRequestTimeoutMs,
            headers: {
                "Content-Type": "application/json"
            }
        },
        ...axiosOptions
    };
    const path = `${apiBase}/newsletter/subscribe`;
    try {
        const response = await axios_default().post(path, values, config);
        if (response.status === 200 || response.status === 201) {
            return true;
        }
        throw new Error(`Sendgrid newsletter subscription was unsuccessful. Status: ${response.status}`);
    } catch (error) {
        const msg = "Error: Sendgrid newsletter subscription was unsuccessful.";
        const err = JSON.stringify((0,logging/* formatLog */.U)({
            error
        }));
        console.error(msg, err);
        return false;
    }
};
/**
 * newsletter opt in from the service API.
 */ const newsletterApiSubscribeRequest = async (email)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , museApiHost , museWebHost  } , serverRuntimeConfig: { emailAlertToken  }  } = getConfig();
    const emailSubscription = {
        email,
        page_section: "search"
    };
    const config = {
        ...{
            timeout: apiRequestTimeoutMs,
            headers: {
                Authorization: `Shared-Token token=${emailAlertToken}`,
                Origin: museWebHost
            }
        }
    };
    const path = `${museApiHost}/api/newsletter/subscribe_with_token`;
    try {
        const response = await axios.post(path, emailSubscription, config);
        return response?.data ?? {};
    } catch (error) {
        const msg = "Error: Unable to subscribe the user to Newsletters";
        const err = JSON.stringify(formatLog({
            error
        }));
        console.error(msg, err);
        return null;
    }
};
const combinedSubscribe = async (values)=>{
    const { alerts , email , newsletter , ...restProps } = values;
    // Remove alerts from this payload
    const jobAlertProps = {
        email,
        newsletter,
        ...restProps
    };
    if (alerts !== "true" && newsletter === "true") {
        const result = newsletterSubscribeRequest({
            email
        }).catch(console.error);
        return result;
    }
    const result1 = jobAlertsSubscribeRequest(jobAlertProps).catch(console.error);
    return result1;
};
/**
 * Request user from the service API.
 */ const fetchApiUser = async (oskarId = "", sessionId = "", axiosOptions)=>{
    const { publicRuntimeConfig: { apiRequestTimeoutMs , museApiHost , museHost  }  } = getConfig();
    const config = {
        ...{
            timeout: apiRequestTimeoutMs,
            headers: {
                "Content-Type": "application/json",
                cookie: `oskar_id=${oskarId}; session_id=${sessionId}`,
                referer: museHost
            }
        },
        ...axiosOptions
    };
    const path = `${museApiHost}/api/user`;
    try {
        const response = await axios(path, config);
        return response;
    } catch (error) {
        const msg = `Search Renderer was unable to request the user from ${path}.`;
        console.error(msg, JSON.stringify(formatLog({
            error
        })));
        return null;
    }
};
/**
 * Fetches job title cities from the API or cache.
 *
 * @param {string} title - The job title.
 * @param {string} state - The state.
 * @returns {Promise<JobTitleCities>} - The job title cities.
 * @throws {Error} - If there is an error fetching the data.
 */ const fetchJobTitleCities = async (title, state)=>{
    const { serverRuntimeConfig: { mockApiResponses  } , publicRuntimeConfig: { appName , staticJSONAssetsHost  } ,  } = (0,next_config["default"])();
    if (!title || !state) return null;
    const cacheTitle = `${title}-${state}`;
    const cachedItem = apiCache.get(cacheTitle);
    if (mockApiResponses) {
        return mockJobsCities_namespaceObject;
    }
    if (cachedItem === undefined) {
        const prefix = `${staticJSONAssetsHost}/list-renderer/job_normalizer/titles/title`;
        const path = `${prefix}/${title}/${state}.json`;
        try {
            const response = await axios_default().get(path, {
                timeout: 3000
            });
            const result = response.data;
            apiCache.set(cacheTitle, result);
            console.info(`${appName} Cache refreshed, ${cacheTitle} retrieved from API.`);
            return result;
        } catch (error) {
            const msg = getFetchError("JSON", "Back-End", path);
            console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
                error
            })));
            return null;
        }
    }
    console.info(`${appName} Cache existing, ${cacheTitle} retrieved from cache.`);
    return cachedItem;
};


/***/ }),

/***/ 7228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LF": function() { return /* binding */ toggleWindowFreeze; },
/* harmony export */   "jU": function() { return /* binding */ isBrowser; },
/* harmony export */   "lT": function() { return /* binding */ generateUrlPath; },
/* harmony export */   "tq": function() { return /* binding */ isMobile; }
/* harmony export */ });
/* unused harmony exports parseQueryParamsToObject, otherKeysContainValues */
/* harmony import */ var _strings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2918);
/* harmony import */ var _reducers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5823);


/**
 * Are we currently within a browser.
 */ const isBrowser = ()=> true && typeof window.document !== "undefined";
/**
 * Is the browser currently set to 768px or less wide.
 * Expects window.innerWidth;
 */ const isMobile = ()=>isBrowser() && window.innerWidth <= 768;
// https://stackoverflow.com/a/8649003
/**
 * Parses a query param string and returns an object of the values
 * @param query - valid string to parse
 */ const parseQueryParamsToObject = (query = "")=>{
    let queryString = query;
    if (queryString && queryString[0] === "?") {
        queryString = queryString.substring(1);
    }
    try {
        return JSON.parse(`{"${decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`);
    } catch  {
        return null;
    }
};
/**
 * Returns a new path.
 */ const generateUrlPath = (params)=>{
    const { companyShortName , locationName , searchKeyword , filters , asPath ,  } = params;
    // get categories from filters and then remove categories from filter
    const filterParams = (0,_strings__WEBPACK_IMPORTED_MODULE_0__/* .objToQueryParams */ .hA)((0,_reducers__WEBPACK_IMPORTED_MODULE_1__/* .removeFalsy */ .S)(filters));
    const hasParamsOtherThanCategory = otherKeysContainValues(filters, "category");
    let searchInputs = "";
    // order is important for SEO here. location > keyword > company
    searchInputs += locationName ? `location/${(0,_strings__WEBPACK_IMPORTED_MODULE_0__/* .slugify */ .lV)(locationName.toLowerCase())}/` : "";
    searchInputs += searchKeyword ? `keyword/${searchKeyword.toLowerCase()}/` : "";
    searchInputs += companyShortName ? `company/${companyShortName.toLowerCase()}/` : "";
    const urlStart = asPath.includes("/hiring") && !hasParamsOtherThanCategory ? "/hiring/" : "/search/";
    const result = `${urlStart}${searchInputs}${filterParams}`;
    return result.slice(-1) === "/" ? result : `${result}/`;
};
const toggleWindowFreeze = ()=>{
    const { body: { style  }  } = document;
    if (style.overflow === "hidden") {
        style.height = "auto";
        style.overflow = "auto";
    } else {
        style.height = "100vh";
        style.overflow = "hidden";
    }
};
/**
 * Loops through an object to see if any properties other
 * than the checkKey property exists. Search has a depth of 1.
 * @param obj - valid object to loop through
 * @param checkKey - valid string to check
 * @returns boolean
 */ const otherKeysContainValues = (obj, checkKey)=>{
    let result = false;
    const objectKeys = Object.getOwnPropertyNames(obj);
    objectKeys.forEach((key)=>{
        if (key !== checkKey && obj[key].length > 0) {
            result = true;
        }
    });
    return result;
};


/***/ }),

/***/ 3135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$q": function() { return /* binding */ states; },
/* harmony export */   "BU": function() { return /* binding */ suggestionApiQueryMaxlength; },
/* harmony export */   "L8": function() { return /* binding */ jobSearchQueryMaxlength; },
/* harmony export */   "RB": function() { return /* binding */ validFilterKeys; },
/* harmony export */   "e7": function() { return /* binding */ months; }
/* harmony export */ });
/* unused harmony exports legacyCompanySize, legacyJobLevel, validParamKeys */
// Months array for date formatting
const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const states = [
    [
        "Alabama",
        "AL"
    ],
    [
        "Alaska",
        "AK"
    ],
    [
        "American Samoa",
        "AS"
    ],
    [
        "Arizona",
        "AZ"
    ],
    [
        "Arkansas",
        "AR"
    ],
    [
        "California",
        "CA"
    ],
    [
        "Colorado",
        "CO"
    ],
    [
        "Connecticut",
        "CT"
    ],
    [
        "Delaware",
        "DE"
    ],
    [
        "District of Columbia",
        "DC"
    ],
    [
        "Florida",
        "FL"
    ],
    [
        "Georgia",
        "GA"
    ],
    [
        "Guam",
        "GU"
    ],
    [
        "Hawaii",
        "HI"
    ],
    [
        "Idaho",
        "ID"
    ],
    [
        "Illinois",
        "IL"
    ],
    [
        "Indiana",
        "IN"
    ],
    [
        "Iowa",
        "IA"
    ],
    [
        "Kansas",
        "KS"
    ],
    [
        "Kentucky",
        "KY"
    ],
    [
        "Louisiana",
        "LA"
    ],
    [
        "Maine",
        "ME"
    ],
    [
        "Maryland",
        "MD"
    ],
    [
        "Massachusetts",
        "MA"
    ],
    [
        "Michigan",
        "MI"
    ],
    [
        "Minnesota",
        "MN"
    ],
    [
        "Mississippi",
        "MS"
    ],
    [
        "Missouri",
        "MO"
    ],
    [
        "Montana",
        "MT"
    ],
    [
        "Nebraska",
        "NE"
    ],
    [
        "Nevada",
        "NV"
    ],
    [
        "New Hampshire",
        "NH"
    ],
    [
        "New Jersey",
        "NJ"
    ],
    [
        "New Mexico",
        "NM"
    ],
    [
        "New York",
        "NY"
    ],
    [
        "North Carolina",
        "NC"
    ],
    [
        "North Dakota",
        "ND"
    ],
    [
        "Northern Mariana Islands",
        "MP"
    ],
    [
        "Ohio",
        "OH"
    ],
    [
        "Oklahoma",
        "OK"
    ],
    [
        "Oregon",
        "OR"
    ],
    [
        "Pennsylvania",
        "PA"
    ],
    [
        "Puerto Rico",
        "PR"
    ],
    [
        "Rhode Island",
        "RI"
    ],
    [
        "South Carolina",
        "SC"
    ],
    [
        "South Dakota",
        "SD"
    ],
    [
        "Tennessee",
        "TN"
    ],
    [
        "Texas",
        "TX"
    ],
    [
        "Trust Territories",
        "TT"
    ],
    [
        "Utah",
        "UT"
    ],
    [
        "Vermont",
        "VT"
    ],
    [
        "Virgin Islands",
        "VI"
    ],
    [
        "Virginia",
        "VA"
    ],
    [
        "Washington",
        "WA"
    ],
    [
        "West Virginia",
        "WV"
    ],
    [
        "Wisconsin",
        "WI"
    ],
    [
        "Wyoming",
        "WY"
    ], 
];
// Character limit for suggestion api
const suggestionApiQueryMaxlength = 70;
// Character limit for job search api
const jobSearchQueryMaxlength = 128;
// legacy search string keys
// TODO: remove non legeacy fields
const validParamKeys = {
    company: "company",
    job_location: "location",
    location: "location",
    job_level: "level",
    keyword: "keyword",
    company_size: "size",
    industry: "industry",
    perks: "perks",
    category: "category",
    work_location: "work_location",
    radius: "radius",
    posted_date_range: "date-posted"
};
const validFilterKeys = {
    company: "company",
    location: "location",
    keyword: "keyword",
    experienceLevel: "level",
    companySize: "size",
    industry: "industry",
    perks: "perks",
    category: "category",
    work_location: "work_location",
    radius: "radius",
    postedDateRange: "date-posted",
    companyLeadership: "company-leadership"
};
const legacyJobLevel = {
    "entry level": "entry",
    "mid level": "mid",
    "senior level": "senior",
    "management level": "management",
    internship: "internship"
};
const legacyCompanySize = {
    "small size": "1_50",
    "medium size": "51_200,201_500",
    "large size": "501_1000,1001_5000,5001_10000,10000_plus"
};



/***/ }),

/***/ 7601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BZ": function() { return /* binding */ getFeatureFlags; }
/* harmony export */ });
/* unused harmony exports isFeatureFlagActive, getActiveFeatureFlags */
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1752);

/**
 * Finds and returns the key in the object that matches the given name ignoring case.
 */ const findKeyIgnoreCase = (obj, name)=>{
    const upperKey = name?.toUpperCase() ?? "";
    if (!upperKey) return null;
    return Object.keys(obj).filter((key)=>key.toUpperCase() === upperKey).shift() ?? null;
};
/**
 * Checks if a value is true or the string value of true.
 */ const isTruthy = (value = false)=>value?.toString().toUpperCase() === "TRUE";
/**
 * Take a name and determine if the feature flags
 * is activated based on environment variable.
 */ const isFeatureFlagActive = (name, query, config)=>{
    // all keys should be upper case
    const queryKey = findKeyIgnoreCase(query, name);
    const configKey = findKeyIgnoreCase(config, name);
    // Did we pass the key in the URL as true?
    if (isTruthy(query[queryKey])) return true;
    // Did we pass the key in the URL as false?
    if (query[queryKey] && !isTruthy(query[queryKey])) return false;
    // Did we enable the key in the config?
    if (isTruthy(config[configKey])) return true;
    return false;
};
/**
 * Returns a list of all existing flags in the config.
 */ const getFeatureFlags = ()=>{
    const { publicRuntimeConfig  } = (0,next_config__WEBPACK_IMPORTED_MODULE_0__["default"])();
    return Object.keys(publicRuntimeConfig).reduce((prev, curr)=>{
        if (/FEATURE_FLAG/i.test(curr)) {
            prev.push(curr);
        }
        return prev;
    }, []);
};
/**
 * Returns all active flags in the config and/or query params.
 */ const getActiveFeatureFlags = (context)=>{
    const { query  } = context;
    const { publicRuntimeConfig  } = getConfig();
    const featureFlagsInQuery = getFeatureFlags().reduce((featureFlags, featureFlag)=>({
            ...featureFlags,
            [featureFlag]: isFeatureFlagActive(featureFlag, query, publicRuntimeConfig)
        }), {});
    return featureFlagsInQuery;
};



/***/ }),

/***/ 4453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ formatLog; }
/* harmony export */ });
/* unused harmony export axiosErrorToLogMap */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);

const axiosErrorToLogMap = {
    http: {
        url: "config.url",
        status_code: "response.status",
        method: "request.method"
    }
};
const LOG_STATUS = {
    INFO: "info",
    WARN: "warn",
    ERROR: "error"
};
/**
 * Formats the message key for the log e.g. HTTP GET /foo/bar
 * @example
 * const message = formatMessage("GET", "foo/bar");
 * console.log(message);
 */ const formatMessage = (method, url)=>`HTTP ${method} ${url}`;
/**
 * Returns the log level string based on the status code
 * @example
 * const logLevel = getLogLevel(500);
 * console.log(logLevel);
 */ const getLogLevel = (statusCode = 200, defaultLevel = LOG_STATUS.INFO)=>{
    switch(Math.floor(statusCode / 100)){
        case 5:
            return LOG_STATUS.ERROR;
        case 4:
            return LOG_STATUS.WARN;
        default:
            return defaultLevel;
    }
};
/**
 * Gets a nested value from on object via a string reference
 * @example
 * const nestedObject = { foo: { bar: 7 } };
 * const nestedValue = getNested(nestedObject, "foo.bar");
 * console.log(nestedValue);
 */ const getNested = (theObject, path, separator = ".")=>{
    try {
        return path.replace("[", separator).replace("]", "").split(separator).reduce((obj, property)=>obj[property], theObject);
    } catch (err) {
        return undefined;
    }
};
/**
 * Creates a new object using the values in mappedObject and the
 * key references in the map. Essentially an object reducer.
 * @example
 * const mappableObject = { foo: { bar: 7 } };
 * const map = { baz: "foo.bar" };
 * const mappedObject = mappedObject(mappableObject, map);
 * console.log(mappedObject);
 */ const mapObj = (mappedObject, map)=>{
    const newObject = {};
    // Traverse the object
    Object.keys(map).forEach((key)=>{
        let newObjectValue;
        if (typeof map[key] === "object") {
            newObjectValue = mapObj(mappedObject, map[key]);
        } else {
            newObjectValue = getNested({
                ...mappedObject
            }, map[key]);
        }
        newObject[key] = newObjectValue;
    });
    return newObject;
};
/**
 * Uses values from a Koa context object and an optional error object
 * to create a formatted log object. Uses mapObj to translate to the
 * desired format. Takes an optional mapping argument to override the default.
 * @example
 * const formattedLog = formatLog(context, error);
 * console.log(formattedLog);
 */ const formatLog = (format)=>{
    const { context , error , contextToLogMap =axiosErrorToLogMap  } = format;
    let contextValues = null;
    let logInfo = null;
    if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error)) {
        contextValues = mapObj({
            ...error
        }, {
            ...contextToLogMap
        });
        logInfo = {
            ...contextValues,
            level: getLogLevel(contextValues?.http?.status_code || error.status),
            message: formatMessage(contextValues.http.method || error.message, contextValues.http.url)
        };
    } else {
        const { req: { method ="" , url =""  } = {} , res: { statusCode =0  } = {}  } = context || {};
        contextValues = mapObj({
            ...context
        }, {
            ...contextToLogMap
        });
        logInfo = {
            ...contextValues,
            level: getLogLevel(statusCode),
            message: formatMessage(method, url)
        };
    }
    const errorValues = error ? {
        message: error.message,
        stack: error.stack,
        kind: error.name
    } : null;
    return {
        ...logInfo,
        ...errorValues && {
            error: errorValues
        }
    };
};


/***/ }),

/***/ 5823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useCombinedReducers; },
/* harmony export */   "S": function() { return /* binding */ removeFalsy; }
/* harmony export */ });
// Stolen directly from https://github.com/the-road-to-learn-react/use-combined-reducers
// because the NPM installed version has a build error which prevents us using it.
const useCombinedReducers = (combinedReducers)=>{
    // Global State
    const state = Object.keys(combinedReducers).reduce((acc, key)=>({
            ...acc,
            [key]: combinedReducers[key][0]
        }), {});
    // Global Dispatch Function
    const dispatch = (action)=>Object.keys(combinedReducers).map((key)=>combinedReducers[key][1])// eslint-disable-next-line @typescript-eslint/no-shadow
        .forEach((fn)=>fn(action));
    return [
        state,
        dispatch
    ];
};
/**
 * Remove any falsy value from an object
 */ const removeFalsy = (obj)=>{
    const newObj = {};
    Object.keys(obj).forEach((prop)=>{
        if (obj[prop]) {
            newObj[prop] = obj[prop];
        }
    });
    return newObj;
};


/***/ }),

/***/ 4299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NB": function() { return /* binding */ companySizeItems; },
/* harmony export */   "Y0": function() { return /* binding */ jobCategoryItems; },
/* harmony export */   "Z5": function() { return /* binding */ searchRadiusItems; },
/* harmony export */   "dK": function() { return /* binding */ postedDateRangeItems; },
/* harmony export */   "fA": function() { return /* binding */ companyIndustryItems; },
/* harmony export */   "kh": function() { return /* binding */ initialRadiusValue; },
/* harmony export */   "s": function() { return /* binding */ experienceLevelItems; },
/* harmony export */   "sg": function() { return /* binding */ flattenPerksAndBenefits; },
/* harmony export */   "uq": function() { return /* binding */ diversityInclusionItems; }
/* harmony export */ });
/* unused harmony exports convertToFacetItemsFormat, convertPerksAndBeniftsToNestedFormat */
/**
 * Experience level items
 */ const experienceLevelItems = [
    {
        label: "Internship",
        value: "internship"
    },
    {
        label: "Entry Level",
        subLabel: "0 - 1 years",
        value: "entry"
    },
    {
        label: "Mid Level",
        subLabel: "1 - 5 years",
        value: "mid"
    },
    {
        label: "Senior Level",
        subLabel: "5 - 10+ years",
        // TODO: Revise this value once it has been fixed by data/platform.
        value: "senior,management"
    }
];
/**
 * Company Size items
 */ const companySizeItems = [
    {
        label: "1-50 employees",
        value: "1_50"
    },
    {
        label: "51-200 employees",
        value: "51_200"
    },
    {
        label: "201-500 employees",
        value: "201_500"
    },
    {
        label: "501 - 1,000 employees",
        value: "501_1000"
    },
    {
        label: "1,001 - 5,000 employees",
        value: "1001_5000"
    },
    {
        label: "5,001 - 10,000 employees",
        value: "5001_10000"
    },
    {
        label: "10,000+ employees",
        value: "10000_plus"
    }
];
const jobCategoryItems = [
    {
        label: "Account Management",
        value: "account_management"
    },
    {
        label: "Accounting and Finance",
        value: "accounting_finance"
    },
    {
        label: "Administration and Office",
        value: "administration_office"
    },
    {
        label: "Advertising and Marketing",
        value: "advertising_marketing"
    },
    {
        label: "Animal Care",
        value: "animal_care"
    },
    {
        label: "Arts",
        value: "arts"
    },
    {
        label: "Business Operations",
        value: "business_operations"
    },
    {
        label: "Cleaning and Facilities",
        value: "cleaning_facilities"
    },
    {
        label: "Computer and IT",
        value: "computer_it"
    },
    {
        label: "Construction",
        value: "construction"
    },
    {
        label: "Customer Service",
        value: "customer_service"
    },
    {
        label: "Data and Analytics",
        value: "data_analytics"
    },
    {
        label: "Design and UX",
        value: "design_ux"
    },
    {
        label: "Education",
        value: "education"
    },
    {
        label: "Energy Generation and Mining",
        value: "energy_generation_mining"
    },
    {
        label: "Entertainment and Travel Services",
        value: "entertainment_travel"
    },
    {
        label: "Farming and Outdoors",
        value: "farming_outdoors"
    },
    {
        label: "Food and Hospitality Services",
        value: "food_hospitality"
    },
    {
        label: "Healthcare",
        value: "healthcare"
    },
    {
        label: "Human Resources and Recruitment",
        value: "human_resources_recruitment"
    },
    {
        label: "Installation, Maintenance, and Repairs",
        value: "installation_maintenance_repairs"
    },
    {
        label: "Legal Services",
        value: "legal"
    },
    {
        label: "Management",
        value: "management"
    },
    {
        label: "Manufacturing and Warehouse",
        value: "manufacturing_warehouse"
    },
    {
        label: "Media, PR, and Communications",
        value: "media_pr_communications"
    },
    {
        label: "Personal Care and Services",
        value: "personal_care"
    },
    {
        label: "Product Management",
        value: "product_management"
    },
    {
        label: "Project Management",
        value: "project_management"
    },
    {
        label: "Protective Services",
        value: "protective_services"
    },
    {
        label: "Real Estate",
        value: "real_estate"
    },
    {
        label: "Retail",
        value: "retail"
    },
    {
        label: "Sales",
        value: "sales"
    },
    {
        label: "Science and Engineering",
        value: "science_engineering"
    },
    {
        label: "Social Services",
        value: "social_services"
    },
    {
        label: "Software Engineering",
        value: "software_engineering"
    },
    {
        label: "Sports, Fitness, and Recreation",
        value: "sports_fitness_recreation"
    },
    {
        label: "Transportation and Logistics",
        value: "transportation_logistics"
    },
    {
        label: "Writing and Editing",
        value: "writing_editing"
    }, 
];
const searchRadiusItems = [
    {
        label: "Anywhere",
        value: ""
    },
    {
        label: "5 miles",
        value: "5mi"
    },
    {
        label: "10 miles",
        value: "10mi"
    },
    {
        label: "25 miles",
        value: "25mi"
    },
    {
        label: "50 miles",
        value: "50mi"
    },
    {
        label: "100 miles",
        value: "100mi"
    }
];
/**
 * Radius value when user selects a location for the first time
 */ const initialRadiusValue = "100mi";
const postedDateRangeItems = [
    {
        label: "Anytime",
        value: ""
    },
    {
        label: "Last 7 days",
        value: "last_7d"
    },
    {
        label: "Last 14 days",
        value: "last_14d"
    },
    {
        label: "Last 30 Days",
        value: "last_30d"
    }
];
const diversityInclusionItems = [
    {
        label: "Diversity, Equity, and Inclusion Program",
        value: "diversity_and_inclusion_program"
    },
    {
        label: "Founder led",
        value: "founder_led"
    },
    {
        label: "Female founded/led",
        value: "female_led"
    },
    {
        label: "Black founded/led",
        value: "black_led"
    },
    {
        label: "BIPOC founded/led",
        value: "bipoc_led"
    },
    {
        label: "Latinx founded/led",
        value: "latinx_led"
    },
    {
        label: "Asian founded/led",
        value: "asian_led"
    },
    {
        label: "LGBTQ+ founded/led",
        value: "lgbtq_led"
    },
    {
        label: "Veteran founded/led",
        value: "veteran_led"
    },
    {
        label: "Unconscious Bias Training",
        value: "unconscious_bias_training"
    }
];
const companyIndustryItems = [
    {
        label: "Accounting",
        value: "accounting"
    },
    {
        label: "Advertising & Agencies",
        value: "advertising_and_agencies"
    },
    {
        label: "Architecture",
        value: "architecture"
    },
    {
        label: "Arts & Music",
        value: "arts_and_music"
    },
    {
        label: "Biotechnology",
        value: "biotechnology"
    },
    {
        label: "Blockchain",
        value: "blockchain"
    },
    {
        label: "Client Services",
        value: "client_services"
    },
    {
        label: "Consulting",
        value: "consulting"
    },
    {
        label: "Consumer Goods & Services",
        value: "consumer"
    },
    {
        label: "Data Science",
        value: "data_science"
    },
    {
        label: "Education",
        value: "education"
    },
    {
        label: "Energy",
        value: "Energy"
    },
    {
        label: "Engineering",
        value: "engineering"
    },
    {
        label: "Entertainment & Gaming",
        value: "entertainment_and_gaming"
    },
    {
        label: "Fashion & Beauty",
        value: "fashion_and_beauty"
    },
    {
        label: "Financial Services",
        value: "finance"
    },
    {
        label: "Fintech",
        value: "fintech"
    },
    {
        label: "Fitness & Wellness",
        value: "fitness_wellness"
    },
    {
        label: "Food & Beverage",
        value: "food"
    },
    {
        label: "Government",
        value: "government"
    },
    {
        label: "Healthcare",
        value: "healthcare"
    },
    {
        label: "Healthtech",
        value: "healthtech"
    },
    {
        label: "Information Technology",
        value: "information_technology"
    },
    {
        label: "Insurance",
        value: "insurance"
    },
    {
        label: "Law",
        value: "law"
    },
    {
        label: "Manufacturing",
        value: "manufacturing"
    },
    {
        label: "Marketing",
        value: "marketing"
    },
    {
        label: "Media",
        value: "media"
    },
    {
        label: "Mortgage",
        value: "mortgage"
    },
    {
        label: "Non-Profit",
        value: "non_profit"
    },
    {
        label: "Pharmaceutical",
        value: "pharmaceutical"
    },
    {
        label: "Public Relations & Communications",
        value: "public_relations_communications"
    },
    {
        label: "Real Estate & Construction",
        value: "real_estate_and_construction"
    },
    {
        label: "Retail",
        value: "retail"
    },
    {
        label: "Social Good",
        value: "social_good"
    },
    {
        label: "Social Media",
        value: "social_media"
    },
    {
        label: "Software",
        value: "software"
    },
    {
        label: "Technology",
        value: "tech"
    },
    {
        label: "Telecom",
        value: "telecom"
    },
    {
        label: "Trading",
        value: "trading"
    },
    {
        label: "Travel & Hospitality",
        value: "travel_and_hospitality"
    },
    {
        label: "Veterinary",
        value: "veterinary"
    }
];
const convertToFacetItemsFormat = (items)=>items.map(({ code , name  })=>({
            label: name,
            value: code
        }));
const flattenPerksAndBenefits = (perks_and_benefits)=>perks_and_benefits.reduce((accum, { items  })=>[
            ...accum,
            ...items
        ], []);
const convertPerksAndBeniftsToNestedFormat = (perks_and_benefits)=>{
    const benefits = Object.values(perks_and_benefits).map(({ name , perks  })=>({
            label: name,
            items: convertToFacetItemsFormat(perks)
        }));
    return benefits;
};


/***/ }),

/***/ 2918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A$": function() { return /* binding */ unSlugify; },
/* harmony export */   "DU": function() { return /* binding */ normalizeLocationName; },
/* harmony export */   "Qs": function() { return /* binding */ titleCase; },
/* harmony export */   "Y8": function() { return /* binding */ getSearchSeoTitle; },
/* harmony export */   "Z2": function() { return /* binding */ getCanonicalUrl; },
/* harmony export */   "ai": function() { return /* binding */ formatNumberComma; },
/* harmony export */   "hA": function() { return /* binding */ objToQueryParams; },
/* harmony export */   "lV": function() { return /* binding */ slugify; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; },
/* harmony export */   "vU": function() { return /* binding */ getSearchSeoDescription; }
/* harmony export */ });
/* unused harmony exports collapseWhiteSpace, generateRandomString, getCompanyFromPath, getSeoNoun, getLocationFromPath, objToQueryString, queryStringToObj, isLandingPage, parsePath, filterValidQueryParams, camelCaseToUnderscore, isTruthy */
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3135);
/* harmony import */ var _searchFacetItems__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4299);
/* harmony import */ var _featureFlags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7601);



/**
 * Convert a word to proper Case.
 */ const titleWordCase = (txt)=>`${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`;
/**
 * Convert a sentence to proper Case.
 */ const titleCase = (txt)=>txt.split(" ").map(titleWordCase).join(" ");
/**
 * Converts a diacritic to normalized character plus accent. Then removes the accent.
 */ const normalizeAccents = (txt)=>txt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
/**
 * Extract the prop from the provided string based on prefix.
 */ const extractProp = (txt, pre)=>{
    const prefix = `${pre}-`;
    const suffix = "-jobs";
    const separator = "+";
    // get the end of the path and remove the query string
    const path = txt.split("/").pop().split("?").shift();
    return path.split(separator).filter((el)=>el.startsWith(prefix)).map(decodeURIComponent).map((el)=>el.replace(prefix, "").replace(suffix, "").replace(/-/g, " ").split(",").join(", ")).shift() ?? "";
};
/**
 * Convert number to string and add a comma for thousands and millions.
 */ const formatNumberComma = (value)=>new Intl.NumberFormat("en-US").format(value);
/**
 * Retrieves the company from the provided string.
 * Assumes you are passing the canonical path.
 */ const getCompanyFromPath = (txt)=>extractProp(txt, "c").split(" ").map(titleCase)// Converts a diacritic to normalized character plus accent. Then removes the accent.
    .map(normalizeAccents).join(" ").replace(/\s\s+/g, " ");
/**
 * Retrieves the location from the provided string.
 * Assumes you are passing the canonical path.
 */ const getLocationFromPath = (txt)=>extractProp(txt, "l").split(" ").map(titleCase).map(normalizeAccents)// Convert State characters to upper case
    .map((item, index, array)=>index === array.length - 1 ? item.toUpperCase() : item).join(" ").replace(/\s\s+/g, " ");
/**
 * Returns the formatted portion of the location for SEO.
 */ const getCanonicalWhere = (splitPath)=>{
    const locationIndex = splitPath.indexOf("location");
    const location = locationIndex > 0 ? [
        "location",
        splitPath[locationIndex + 1]
    ] : [];
    if (location.length > 0 && location[1] === "flexible-remote") {
        location[1] = "remote-flexible";
    }
    return location;
};
/**
 * Returns the formatted category for SEO.
 */ const getCanonicalCategory = (splitPath)=>{
    const categoryIndex = splitPath.indexOf("category");
    let category = [];
    if (categoryIndex >= 0) {
        category = [
            "category",
            splitPath[categoryIndex + 1]
        ];
        // If there is more than one category then choose the first category.
        if (category[1].toLowerCase().includes("%2c")) {
            const splitCategories = category[1].toLowerCase().split("%2c").filter(Boolean);
            category = [
                "category",
                splitCategories[0]
            ];
        }
    }
    return category;
};
/**
 * gets the canonical priority "what". Order of priority: keyword > company > category
 */ const getCanonicalWhat = (splitPath)=>{
    // Companies
    const companyIndex = splitPath.indexOf("company");
    const company = companyIndex > 0 ? [
        "company",
        splitPath[companyIndex + 1]
    ] : [];
    // Categories
    const category = getCanonicalCategory(splitPath);
    // Keywords
    const keywordIndex = splitPath.indexOf("keyword");
    const keyword = keywordIndex > 0 ? [
        "keyword",
        slugify(splitPath[keywordIndex + 1])
    ] : [];
    // We need to choose only one facet between keyword, company or category
    // order of priority: keyword > company > category
    let priorityFacet = [];
    if (keyword.length) {
        priorityFacet = keyword;
    } else if (company.length) {
        priorityFacet = company;
    } else if (category.length) {
        priorityFacet = category;
    }
    return priorityFacet;
};
/**
 * generate the canonical URL.
 */ const getCanonicalUrl = (asPath = "/")=>{
    const preface = "https://www.themuse.com";
    const splitPath = asPath.split("?")[0].split("/").filter(Boolean);
    const route = "hiring";
    const location = getCanonicalWhere(splitPath);
    const priorityFacet = getCanonicalWhat(splitPath);
    // If the path contains facets but NONE of the acceptable ones (keyword, location, company, category)
    // We return null as there should be no canonical URL
    if (splitPath.length > 1 && !(location.length || priorityFacet.length)) {
        return null;
    }
    // facets order: location always comes first when it exists
    const canonical = [
        preface,
        route,
        ...location,
        ...priorityFacet, 
    ].filter(Boolean).join("/");
    return `${canonical}/`;
};
/**
 * Get the label portion of a GroupListItem.
 */ const getFilterLabel = (filterString)=>{
    const filteredCategory = _searchFacetItems__WEBPACK_IMPORTED_MODULE_1__/* .jobCategoryItems */ .Y0?.filter((category)=>category.value === filterString);
    return filteredCategory[0]?.label || "";
};
/**
 * Selects the right SEO what
 * Order of priority: keyword > company > category
 * @param keyword string
 * @param company string
 * @param category string
 * @returns string
 */ const getSeoWhat = (keyword, company, category)=>{
    if (keyword) {
        return `${keyword} `;
    }
    if (company) {
        return `${company} `;
    }
    if (category) {
        return `${getFilterLabel(category)} `;
    }
    return "";
};
/**
 * returns the formatted where for seo title and description
 * @param location: string
 * @param total: count
 * @returns string
 */ const getSeoWhere = (location)=>{
    if (location) {
        return isRemoteCheck(location) ? "Remote-Friendly " : ` in ${location}`;
    }
    return "";
};
/**
 * Return singular or plural job(s).
 */ const getSeoNoun = (total, isRemote, what)=>{
    if (what || isRemote) {
        return total === 1 ? "job" : "jobs";
    }
    return total === 1 ? "Job" : "Jobs";
};
/**
 * Returns an object containing a string describing search results.
 * @param location: string
 * @param keyword: string
 * @param company: string
 * @param category: string
 * @param total: number
 * @returns object
 */ const getSearchSeoTitle = (location, keyword, company, category, total)=>{
    const isRemote = /remote/i.test(location);
    const totalString = total >= 10000 ? "10,000+ " : `${formatNumberComma(total)} `;
    const what = getSeoWhat(keyword, company, category);
    const where = getSeoWhere(location);
    const noun = getSeoNoun(total, isRemote, what);
    const suffix = isRemote ? `${where}${what}${noun}` : `${what}${noun}${where}`;
    return {
        totalString,
        suffix
    };
};
/**
 * Returns a string describing search results.
 * @param location string
 * @param keyword: string
 * @param company: string
 * @param category: string
 * @param total: number
 * @returns object
 */ const getSearchSeoDescription = (location, keyword, company, category, total)=>{
    const isRemote = /remote/i.test(location);
    const what = getSeoWhat(keyword, company, category);
    const noun = getSeoNoun(total, isRemote, what);
    const where = getSeoWhere(location);
    const prefix = isRemote ? `${where}${what}${noun}` : `${what}${noun}${where}`;
    return `${prefix} hiring now on The Muse.`;
};
/**
 * Is this one of the 3 named landing pages.
 * Basically we should index any page that is one of:
 * * company filter with no other filters
 * * location filter with no other filters
 * * category filter with no other filters
 */ const isLandingPage = (txt = "")=>{
    // begins with /search
    // followed by company or location or category
    // followed by a slash
    // followed by a random string
    // followed by at most 1 slash but nothing else
    const regex = new RegExp(/^\/hiring\/(company|location|category)\/[a-zA-Z0-9-]+.\/?$/);
    return regex.test(txt.split("?")[0]);
};
const parsePath = (urlPath)=>{
    const regex = /^\/((search|hiring)\/)?/;
    return urlPath.replace(regex, "").split("/").reduce((values, pathPart, index, shortenedPath)=>{
        const localValues = values;
        if (index % 2) {
            localValues[shortenedPath[index - 1]] = pathPart;
        } else {
            localValues[pathPart] = "";
        }
        return localValues;
    }, {});
};
/**
 * Rename the query params to the correct new values
 */ const filterValidQueryParams = (paths)=>{
    const flags = getFeatureFlags();
    return Object.keys(paths).reduce((values, currentValue)=>{
        const localValues = values;
        const validParams = Object.values(validFilterKeys).concat(Object.values(flags));
        if (validParams.includes(currentValue)) {
            const param = validParams[validParams.indexOf(currentValue)];
            localValues[param] = paths[currentValue];
        }
        return localValues;
    }, {});
};
/**
 *  Rename the object names to query param names
 */ const objToQueryParams = (obj)=>{
    const mappedObj = Object.keys(obj).reduce((acc, key)=>({
            ...acc,
            ...{
                [_constants__WEBPACK_IMPORTED_MODULE_0__/* .validFilterKeys */ .RB[key] || key]: encodeURIComponent(obj[key])
            }
        }), {});
    const queryParamStr = Object.keys(mappedObj).filter((key)=>{
        if (mappedObj[key] && mappedObj[key].length > 0) {
            return key;
        }
        return null;
    }).map((key)=>`${key}/${mappedObj[key] || ""}`).join("/");
    return queryParamStr;
};
/**
 * Convert the query string into an object
 */ const queryStringToObj = (searchString)=>{
    const pairs = searchString.split("&");
    const result = {};
    pairs.forEach((pair)=>{
        const pairSplit = pair.split("=");
        let pairSplitValue;
        try {
            pairSplitValue = decodeURIComponent(pairSplit[1] ?? "");
        } catch (error) {
            pairSplitValue = pairSplit[1] ?? "";
        }
        if (pairSplit[0] in result) {
            // check for additional values and add it to the result[key]
            const splitValues = result[pairSplit[0]].split(",");
            splitValues.push(pairSplitValue);
            result[pairSplit[0]] = splitValues.join(",");
        } else {
            result[pairSplit[0]] = pairSplitValue;
        }
    });
    return result;
};
/**
 * Convert an object to query string removing nulls.
 */ const objToQueryString = (obj)=>Object.keys(obj).map((key)=>`${key}=${obj[key] || ""}`).join("&");
/**
 * Remove all contiguous whiteSpace,
 * * ' ' spaces.
 * * \n linefeed (LF or 0x0A (10) in ASCII).
 * * \r carriage return (CR or 0x0D (13) in ASCII).
 * * \t horizontal tab (HT or 0x09 (9) in ASCII).
 * * \v vertical tab (VT or 0x0B (11) in ASCII).
 * * \f form feed (FF or 0x0C (12) in ASCII).
 */ const collapseWhiteSpace = (content)=>(content || "").trim().replace(/[ \n\r\t\v\f]+/gm, " "); // replace non-printing characters
/**
 * Convert a string to a slug.
 * * Decode URL encoded strings.
 * * Remove all white space with collapseWhiteSpace.
 * * Convert all diacritic to generics.
 * * Replace not alpha-numerics with dashes.
 * * Collapse all dashes to one dash.
 */ const slugify = (text)=>decodeURIComponent(collapseWhiteSpace(text || "")).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/gmi, "-").replace(/-+/g, "-");
/**
 * Replace slugs with spaces and Title case each word
 */ const unSlugify = (text = "")=>titleCase(text.split("-").join(" "));
/**
 * Formats a date in correct format for job card
 */ const formatDate = (date)=>{
    const month = _constants__WEBPACK_IMPORTED_MODULE_0__/* .months */ .e7[date.getMonth()];
    const day = date.getUTCDate();
    return `${month} ${day}`;
};
/**
 * Checks to see if the provided location should be considered 'remote'
 */ const isRemoteCheck = (location)=>location ? [
        "Remote / Flexible",
        "Flexible / Remote"
    ].map((remoteString)=>remoteString.toLowerCase()).includes(location.toLowerCase()) : false;
/**
 * Returns a string normalized location display.
 * @param locationName string
 * @returns string
 */ const normalizeLocationName = (locationName)=>{
    if (slugify(locationName) === "flexible-remote") {
        return "Remote / Flexible";
    }
    return locationName;
};
/**
 * Generates a random 36 character Alpha Numeric string.
 */ const generateRandomString = ()=>Math.random().toString(36).substring(2);
/**
 * Replace all non alpha characters with underscores leaving . and + in place.
 */ const camelCaseToUnderscore = (string)=>string.replace(/(\.?([A-Z]+))/g, (match)=>`_${match.toLowerCase()}`);
/**
 * Returns true if the param is truthy or the string true.
 */ const isTruthy = (string)=>/^(true|1)$/.test(string.toLowerCase());



/***/ })

}]);